<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/agro_exporter/production/uniq_final_packing_list/list_containers.yml"
  lang="yaml"
></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="ae_production_uniq_final_packing_list_list_processes_path"
  >
  </go-back-link>

  <agro-exporter-process-header
    :agro_exporter_process_id="agro_exporter_process_id"
  />

  <template v-if="load_data_general">
    <h1 class="page-title">
      <i class="fa-solid fa-container-storage"></i
      ><span class="space-icon"></span>
      {{ $t("labels.title") }}
    </h1>

    <div class="mt-8 flex flex-row">
      <div class="panel-plain-label">
        <badge-default
          :label="
            containers.length + ' ' + $t('labels.total_number_containers')
          "
        />
      </div>
    </div>

    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.week") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.container_code") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.exporter_process_crop_category") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.exporter_process_crop_variety") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.exporter_process_brand") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.gross_weight") }} (Kg)
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.net_weight") }} (Kg)
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.package_groups") }}
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="container in containers"
                  :key="container.id"
                >
                  <td class="table-cell">
                    {{ container.week }}
                  </td>
                  <td class="table-cell-main">
                    {{ container.container_code }}
                  </td>
                  <td class="table-cell">
                    {{ container.category_name }}
                  </td>
                  <td class="table-cell">
                    {{ container.variety_name }}
                  </td>
                  <td class="table-cell">
                    {{ container.brand_name }}
                  </td>
                  <td class="table-cell">
                    {{ container.gross_weight }}
                  </td>
                  <td class="table-cell">
                    {{ container.net_weight }}
                  </td>
                  <td class="table-cell">
                    {{ container.package_groups.length }}
                  </td>
                  <td class="table-cell-action">
                    <button class="link" @click="showContainer(container)">
                      <i class="fa-solid fa-pen"></i
                      ><span class="space-icon"></span>
                      {{ $t("labels.manage_link") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import UniqFinalPackingListRequester from "@/views/agro_exporter/requesters/production/uniq_final_packing_list.js";
import AgroExporterProcessHeader from "@/components/views/agro_exporter/production/uniq_final_packing_list/AgroExporterProcessHeader.vue";

export default {
  name: "AEProductionBasicContainerExportShowProcesses",
  components: { AgroExporterProcessHeader },
  props: ["agro_exporter_process_id", "agro_exporter_id"],
  data() {
    return {
      load_data_general: false,
      containers: [],
    };
  },
  methods: {
    fetchContainers: async function () {
      let response = await UniqFinalPackingListRequester.fetchContainers(
        this.agro_exporter_process_id
      );
      this.containers = response.data;
      this.load_data_general = true;
    },
    showContainer: function (container) {
      this.$router.push({
        name: this.routeName("show_container"),
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: container.id,
        },
      });
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id,
        },
      }).then(() => this.fetchContainers())
    );
  },
};
</script>
